import { render } from "./milestone-plan-onboarding-dialog.vue?vue&type=template&id=582087fe&ts=true"
import script from "./milestone-plan-onboarding-dialog.vue?vue&type=script&lang=ts"
export * from "./milestone-plan-onboarding-dialog.vue?vue&type=script&lang=ts"

import "./milestone-plan-onboarding-dialog.vue?vue&type=style&index=0&id=582087fe&lang=scss"
import "./milestone-plan-onboarding-dialog.vue?vue&type=style&index=1&id=582087fe&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__